import styled from '@emotion/styled';

export type StyledDivProps = React.HTMLAttributes<HTMLDivElement>;

const StyledDiv = styled.div<StyledDivProps>({
  margin: '12px 0 40px 0'
});

export default StyledDiv;
